export default function Contact() {
    return (
        <iframe
            width='100%'
            height='100%'
            frameBorder='0'
            className='min-h-[100vh] lg:min-h-[70vh] max-w-[600px]'
            src='https://miess.octadesk.com/custom-form/00000000-0000-0000-0000-000000000000?linkStyle=https%3A%2F%2Fwww.miess.com.br%2F'
        >
        </iframe>
    )
}
